<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Ondernemingsvermogen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het ondernemingsvermogen bestaat uit:
                <li class="list">eigen vermogen</li>
                <li class="list">egalisatiereserve</li>
                <li class="list">herinvesteringsreserve</li>
                <li class="list">oudedagsreserve</li>
            </div>

            Het eigen vermogen is het bedrag dat is geïnvesteerd in de onderneming. Het eigen vermogen is: de
            bezittingen (activa) min de schulden (passiva).
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Egalisatiereserve
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je mag een egalisatiereserve vormen voor kosten en lasten van de
                bedrijfsuitoefening van dit boekjaar die pas in een later jaar tot een piek in de uitgaven leiden.
                <div class="space10"></div>
                De voorwaarden voor het vormen van de egalisatiereserve zijn:
                <li class="list">Het gaat om toekomstige uitgaven wegens kosten.</li>
                <li class="list">De kosten worden verdeeld in de toekomst uitgegeven.</li>
                <li class="list">De kosten zijn noodzakelijk geworden door de bedrijfsuitoefening in het jaar van
                    dotatie (toevoeging).
                </li>
                <li class="list">De kosten die in een bepaald jaar zijn opgeroepen, leiden in een komend jaar tot een
                    piek in de uitgaven.
                </li>
                <li class="list">Er is een redelijke mate van zekerheid dat de uitgaven zich zullen voordoen.</li>
                <div class="space10"></div>
                Bijvoorbeeld onderhoudskosten aan een gebouw, waarbij het daadwerkelijke onderhoud periodiek in de loop
                van een aantal jaren plaatsvindt.
                <div class="space10"></div>

                Let op! Het gaat hierbij niet om kosten voor toekomstige aanschaf of verbetering van bedrijfsmiddelen.
                Deze uitgaven voor aanschaf of verbetering van een bedrijfsmiddel breng je namelijk al in mindering op
                de winst door de jaarlijkse afschrijving op dit bedrijfsmiddel. Is er een cv in de zeescheepvaart- of
                filmindustrie? Dan mag je geen egalisatiereserve vormen.

                <div class="space10"></div>
                <b>Te reserveren bedrag</b><br/>
                Het bedrag dat je mag reserveren, hangt af van de schatting van de hoogte van de kosten en het tijdstip
                waarop je de kosten maakt. Blijkt achteraf dat de schatting te hoog is uitgevallen? Dan moet je het
                overschot in de winst opnemen. De jaarlijkse toevoeging hoeft niet altijd gelijk te zijn. Deze kan
                bijvoorbeeld wijzigen als de kosten stijgen of de periode verandert.

                <div class="space10"></div>
                <b>Reserve per bedrijfsmiddel</b><br/>
                je mag een aparte reserve vormen per bedrijfsmiddel. Het is ook mogelijk dat je een reserve vormt per
                object, bijvoorbeeld voor onderhoud dat eens per 10 jaar en onderhoud dat eens per 15 jaar moet worden
                verricht. In de balans vermeld je de boekwaarde van het totaal van de afzonderlijke egalisatiereserves.

                <div class="space10"></div>
                <b>Afname van de reserve</b><br/>
                In het jaar waarin je de kosten (van bijvoorbeeld het onderhoud) maakt, boek je de kosten af op de
                egalisatiereserve. Als de reserve hoger is dan de gemaakte kosten, dan moet je het restant van de
                reserve opnemen in de winst. Zijn de kosten hoger dan de gevormde reserve, dan trek je de hogere kosten
                in 1 keer af van de winst.
                <div class="space10"></div>
                Je moet de reserve ook in de winst opnemen als het doel waarvoor de reserve ooit is gevormd, is komen te
                vervallen. Dit is bijvoorbeeld het geval als het bedrijfsmiddel wordt verkocht waarvoor je de reserve
                had gevormd, of als het bedrijfsmiddel verloren gaat.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Herinvesteringsreserve
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je mag boekwinst op bedrijfsmiddelen opnemen in de herinvesteringsreserve. De voorwaarde hiervoor
                is dat er op de balansdatum een voornemen is om te herinvesteren in een bedrijfsmiddel. Je neemt dan de
                boekwinst van het verkochte bedrijfsmiddel niet op in de fiscale winst, maar voegt deze toe aan de
                herinvesteringsreserve. Zo voorkom je dat er direct belasting wordt geheven over die boekwinst.
                <div class="space10"></div>
                Let op! Is er een cv in de zeescheepvaart- of filmindustrie? Dan mag je geen herinvesteringsreserve
                vormen.

                <div class="space10"></div>
                <b>Afname herinvesteringsreserve</b><br/>
                Wordt er vervolgens geherinvesteerd? Je moet dan de gereserveerde boekwinst meteen afboeken op de
                aanschafprijs van het aangeschafte bedrijfsmiddel. Door deze afboeking mag de boekwaarde van het nieuwe
                bedrijfsmiddel niet lager worden dan de boekwaarde van het vervreemde bedrijfsmiddel op het moment van
                vervreemding. Het restant van de reserve kun je afboeken op een eventuele volgende investering die de
                ondernemer binnen de herinvesteringstermijn doet.
                <div class="space10"></div>
                De afboeking verlaagt de afschrijving van het nieuwe bedrijfsmiddel.

                <div class="space10"></div>
                <b>Verzekeringsuitkering voor verdwenen of beschadigd bedrijfsmiddel</b><br/>
                Ontvangt de ondernemer een verzekeringsuitkering voor een verdwenen of beschadigd bedrijfsmiddel? Dan
                mag je de eventuele boekwinst gebruiken als afboeking op de kostprijs van een nieuw bedrijfsmiddel. Ook
                dan mag de boekwaarde van het nieuwe bedrijfsmiddel niet dalen onder de boekwaarde van het oude
                bedrijfsmiddel.

                <div class="space10"></div>
                <b>Uitzondering verplicht afboeken herinvesteringsreserve</b><br/>
                Op het verplicht afboeken van de herinvesteringsreserve bestaat een uitzondering. De
                herinvesteringsreserve die ontstaat door de vervreemding van een bedrijfsmiddel waarop je niet
                afschrijft of waarop je in meer dan 10 jaar afschrijft, hoef je namelijk pas af te boeken als de
                ondernemer een bedrijfsmiddel aanschaft met eenzelfde economische functie als het vervreemde
                bedrijfsmiddel. Je bent bijvoorbeeld niet verplicht de herinvesteringsreserve van een verkocht
                bedrijfspand af te boeken op de aanschaffing van een computer. Maar het mag wel.

                Schaft de ondernemer een bedrijfsmiddel aan waarop je niet afschrijft of waarop je in meer dan 10 jaar
                afschrijft? Dan mag je hier niet zomaar je herinvesteringsreserve op afboeken. Je mag op deze
                investering alleen een herinvesteringsreserve afboeken die is ontstaan door de vervreemding van een
                bedrijfsmiddel met eenzelfde economische functie als het aangeschafte bedrijfsmiddel. Je mag dus niet de
                gereserveerde boekwinst op bijvoorbeeld een computer afboeken op de aanschaffingskosten van een pand.

                <div class="space10"></div>
                <b> Vrijval herinvesteringsreserve</b><br/>
                Je moet de herinvesteringsreserve (of het restant daarvan) toevoegen aan de winst op het moment dat de
                ondernemer niet meer van plan is om te herinvesteren. Zo vindt alsnog belastingheffing over de boekwinst
                plaats.
                <div class="space10"></div>
                De reserve (of het restant daarvan) valt ook vrij als er 3 jaar verstreken zijn na het boekjaar waarin
                de ondernemer de reserve heeft gevormd en de ondernemer nog niet een herinvestering heeft gedaan. Je
                kunt deze termijn van 3 jaar verlengen als:
                <li class="list>">voor de herinvestering een langer tijdvak vereist is in verband met de aard van de
                    bedrijfsmiddelen die je wilt aanschaffen of voortbrengen
                </li>
                <li class="list>">de herinvestering door bijzondere omstandigheden is vertraagd.<br/>
                    Voorwaarde hierbij is dat de uitvoering van de aanschaf of voortbrenging al is gestart.
                </li>
                <div class="space10"></div>
                <b>Specificatie van herinvesteringsreserve</b>
                <li class="list">Omschrijving bedrijfsmiddel<br/>
                    Geef een omschrijving van het bedrijfsmiddel dat is vervreemd.
                </li>
                <li class="list">Vervreemdingsjaar<br/>
                    Kies het jaar waarin het bedrijfsmiddel is vervreemd.
                </li>
                <li class="list">Boekwinst<br/>
                    Vul in: het deel van de boekwinst dat nog niet is geherinvesteerd.
                </li>
                <li class="list">% afschrijving<br/>
                    Vul het afschrijvingspercentage in dat is gebruikt op het vervreemde bedrijfsmiddel.
                </li>
                <li class="list">Boekwaarde op vervreemdingsmoment<br/>
                    Vul de boekwaarde in die het bedrijfsmiddel had op het moment van de vervreemding.
                </li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Oudedagsreserve
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als ondernemer mocht je tot en met het jaar 2022 jaarlijks een deel van de winst reserveren voor de
                oudedagsvoorziening. Dat gereserveerde deel heet de oudedagsreserve. Het vormen van een oudedagsreserve
                betekent niet dat er daadwerkelijk geld opzij gezet wordt: het is een reservering van een deel van de
                winst. Deze reservering zorgt voor uitstel van belastingheffing over dat deel van de winst. Dit levert
                de ondernemer dus op de korte termijn belastingvoordeel op.
                <div class="space10"></div>
                Vanaf het jaar 2023 mag er niet meer worden toegevoegd aan de oudedagsreserve. Dit
                is alleen anders in geval van een gebroken boekjaar dat voor 1 januari 2023 begint en daarna eindigt.
                <div class="space10"></div>
                Een ondernemer kan de oudedagsvoorziening regelen door bijvoorbeeld de aankoop van een lijfrente bij een
                verzekeraar. De oudedagsreserve neemt af als de ondernemer voor (een deel van) de reserve een lijfrente
                aankoopt. Het bedrag waarmee de reserve afneemt, is belastbare winst. Daar staat tegenover dat de
                ondernemer de premie voor de aangekochte lijfrente kunt aftrekken.
                <div class="space10"></div>
                <b>Afname van de oudedagsreserve</b><br/>
                In de volgende situaties neemt de oudedagsreserve af of wordt deze opgeheven:
                <li class="list">Je koopt een lijfrente voor een inkomensvoorziening, en je vermeldt in de aangifte de
                    afname van de oudedagsreserve voor hetzelfde bedrag.
                </li>
                <li class="list">Het bedrag van de oudedagsreserve is hoger dan het ondernemingsvermogen, terwijl zich
                    daarbij 1 van
                    de volgende situaties voordoet:<br/>
                    - De ondernemer staakt de onderneming geheel of gedeeltelijk.<br/>
                    - De ondernemer heeft op 1 januari van het kalenderjaar de AOW-leeftijd bereikt.<br/>
                    - De ondernemer voldoet dit kalenderjaar en het vorige kalenderjaar niet aan het urencriterium.
                </li>
                <div class="space10"></div>
                Een afname of opheffing van je oudedagsreserve betekent in principe dat er een hogere winst ontstaat.
                Tegenover de winstbijtelling staat de aftrek van het bedrag dat de ondernemer betaalt bij de aankoop van
                een lijfrente.
                <div class="space10"></div>
                De regels rond de afname van de reserve blijven gelden na het afschaffen van de oudedagsreserve in 2023.
                <div class="space10"></div>
                Meer informatie over de oudedagsreserve vind je <a target="_blank"
                                                                   href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/winst/inkomstenbelasting/inkomstenbelasting_voor_ondernemers/fiscale_reserves/oudedagsreserve">hier</a>.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Garantie- en overige voorzieningen
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Garantievoorziening</b><br/>
                Bestaat op de balansdatum een reële kans dat de onderneming zal worden aangesproken voor een verleende
                garantie? Dan mag je daarvoor een garantievoorziening opvoeren. De grootte van de voorziening kun je
                meestal bepalen aan de hand van de bedragen waarvoor de onderneming in het verleden is aangesproken.

                <div class="space10"></div>

                <b>Overige voorzieningen</b><br/>
                Vul de boekwaarde in van de overige voorzieningen.<br/>
                Hieronder vallen bijvoorbeeld:=
                <li class="list">lijfrentevoorziening</li>
                <li class="list">pensioenvoorziening</li>
                <li class="list">VUT-voorziening</li>
                <li class="list">milieuvoorziening</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Langlopende schulden kredietinstellingen en overige langlopende schulden
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Schulden aan kredietinstellingen</b><br/>
                Bij rentedragende schulden vul je het nominale bedrag in. Als het gaat om renteloze schulden of schulden
                met een zeer lage rente, dan moet je de schuld waarderen alsof een gebruikelijke rente verschuldigd zou
                zijn (contante waarde).

                <div class="space10"></div>

                <b>Overige langlopende schulden</b><br/>
                Dit zijn bijvoorbeeld:
                <li class="list">obligaties</li>
                <li class="list">onderhandse leningen</li>
                <li class="list">langlopende schulden aan gelieerde maatschappijen</li>
                <li class="list">langlopende schulden aan participanten</li>
                <div class="space10"></div>

                <b>Nominale waarde</b>
                De nominale waarde van de schulden is de oorspronkelijke waarde van de schuld aan het einde van het boekjaar.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Crediteuren, omzetbelasting, loonheffingen en overige kortlopende schulden
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Omzetbelasting</b><br/>
                Het gaat om de schuld van aangiften omzetbelasting die op de balansdatum nog niet zijn verwerkt, zoals
                de laatst ingediende maand- of kwartaalaangifte. Wanneer je een bedrag aan omzetbelasting als schuld
                opgeeft, moet je dit vervolgens specificeren.

                <div class="space10"></div>

                <b>Loonheffingen</b><br/>
                Het gaat om de schuld van aangiften loonheffingen die op de balansdatum nog niet zijn verwerkt, zoals de
                laatst ingediende maandaangifte. Vermeld ook eventuele nog te betalen bedragen van eerdere tijdvakken,
                die je constateert bij het opmaken van de jaarstukken. Als deze verschillen leiden tot een te betalen
                bedrag, dan moet je dit bij de eerstvolgende aangifte loonheffingen corrigeren.

                <div class="space10"></div>

                <b>Overige kortlopende schulden</b><br/>
                Dit zijn bijvoorbeeld:
                <li class="list">kortlopende schulden aan gelieerde maatschappijen</li>
                <li class="list">kortlopende schulden aan participanten</li>
                <li class="list">overlopende passiva.<br/>Dit zijn diensten of goederen die de ondernemer nog moet
                    leveren maar waar hij al wel voor is betaald.</li>
            </div>
        </div>
    </div>

</div>

